// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import React from 'react'
import { createRoot } from 'react-dom/client'
import "./components/index" // Import all React components

const components = {
  'GoogleSignInButton': window.GoogleSignInButton,
  'PositionTrendChart': window.PositionTrendChart,
  'AiModeCitationsChart': window.AiModeCitationsChart
}

function mountReactComponents() {
  const mountPoints = document.querySelectorAll('[data-react-component]')
  mountPoints.forEach((mountPoint) => {
    const { dataset: { reactComponent, props } } = mountPoint
    const Component = components[reactComponent]
    if (Component) {
      const propsObj = props ? JSON.parse(props) : {}
      const root = createRoot(mountPoint)
      root.render(
        <Component {...propsObj} />
      )
    } else {
      console.error(`Component ${reactComponent} not found`)
    }
  })
}

// Mount components on initial page load
document.addEventListener('DOMContentLoaded', mountReactComponents)

// Mount components on Turbo Drive navigation and Turbo Stream updates
document.addEventListener('turbo:load', mountReactComponents)
document.addEventListener('turbo:render', mountReactComponents)
